(() => {
  'use strict';
  function initOptions(scope = document) {
    scope.querySelectorAll('[data-noyvad-options]:not([data-ready])').forEach(widget => {
      const picker = widget.closest('variant-selects');
      if (!picker) return;
      let variants, selected;
      try {
        variants = JSON.parse(widget.querySelector('[data-noyvad-variants]').textContent);
        selected = JSON.parse(picker.querySelector('[data-selected-variant]').textContent);
      } catch { return; }
      const size = widget.querySelector('[data-noyvad-size]');
      const color = widget.querySelector('[data-noyvad-color]');
      const packing = picker.dataset.productHandle === 'travel-packing-organizer-set';
      const rows = variants.map(variant => {
        const parts = variant.options[0].split(/\s*[—–]\s*/);
        return { variant, color: parts[0].trim(), size: packing ? parts[1] : parts.length > 1 ? widget.dataset.large : widget.dataset.small };
      });
      if (!rows.length || rows.some(row => !row.size)) return;
      const initial = rows.find(row => row.variant.id === selected?.id) || rows[0];
      const populate = (select, values, value) => {
        select.replaceChildren(...values.map(text => new Option(text, text, false, text === value)));
      };
      populate(size, [...new Set(rows.map(row => row.size))], initial.size);
      const populateColors = preferred => populate(color, [...new Set(rows.filter(row => row.size === size.value).map(row => row.color))], preferred);
      populateColors(initial.color);
      widget.addEventListener('change', event => {
        if (event.target !== size && event.target !== color) return;
        event.stopPropagation();
        if (event.target === size) populateColors(color.value);
        const row = rows.find(item => item.size === size.value && item.color === color.value);
        const input = row && [...picker.querySelectorAll('input[type="radio"]')].find(item => item.value === row.variant.options[0]);
        if (input && !input.checked) input.click();
      });
      widget.dataset.ready = 'true';
      picker.dataset.noyvadEnhanced = 'true';
      widget.hidden = false;
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('.travel-mobile-menu a');
    if (!link) return;
    const menu = link.closest('details');
    menu.open = false;
    if (link.hash && new URL(link.href).pathname === location.pathname) {
      const target = document.getElementById(link.hash.slice(1));
      if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.travel-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  let queued = false;
  const observer = new MutationObserver(records => {
    if (queued || !records.some(record => record.addedNodes.length)) return;
    queued = true;
    queueMicrotask(() => { queued = false; initOptions(); });
  });
  const start = () => { initOptions(); observer.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
